import { createTheme } from '@mui/material/styles';

export const getAppTheme = (darkMode) =>
  createTheme({
    palette: {
      mode: darkMode ? "dark" : "light",
      background: {
        default: darkMode ? "#262b2e" : "#f4f6f8",
        paper: darkMode ? "#262b2e" : "#fff",
      },
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      fontSize: 13,
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundColor: darkMode ? "#262b2e" : "#f4f6f8",
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            fontSize: "13px",
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: "none",
            backgroundColor: darkMode ? "#262b2e" : "#fff",
            borderRadius: "16px",
            boxShadow: darkMode 
              ? "0 8px 32px 0 rgba(0, 0, 0, 0.4)" 
              : "0 8px 32px 0 rgba(31, 38, 135, 0.07)",
            border: darkMode ? "1px solid rgba(255, 255, 255, 0.08)" : "1px solid rgba(255, 255, 255, 0.18)",
            padding: "8px",
          },
        },
      },
      MuiAccordion: {
        styleOverrides: {
          root: {
            backgroundImage: "none",
          },
        },
      },
      MuiAlert: {
        styleOverrides: {
          root: {
            borderRadius: "10px",
          },
          standardSuccess: {
            backgroundColor: darkMode ? "#14532d" : "#edf7ed",
            color: darkMode ? "#f0fdf4" : "#1e4620",
            border: darkMode ? "1px solid #16a34a" : undefined,
          },
          filledSuccess: {
            backgroundColor: darkMode ? "#15803d" : "#2e7d32",
            color: "#ffffff",
          },
        },
      },
    },
  });